/* 全路由配置 */
import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
//push
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
//replace
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
//默认通过
const accessList = [
  "loginAdmin",
  "login",
  "webHomeIndex",
  "notFound",
  "notLicense",
  "eventServiceOnLine",
  "formWrite",
  "platformSelection",
  "biDetail", // 勿删，路由白名单。跳转应用中心查看
  "targetDisplay", //数据报告插入图表，指标展示
  // 账户管理
  "accountSettings",
  // BI预警详情
  "indicatorWarningDetails",
  "calendar", //日程
  "taskManagementFormDetail",
  "formPreview",
  "taskFormWrite",
  "fillingRecordsDetail",
  "dataTablePreview",

  "errorCorrectionPage",
  "processMonitorDetail",
  "dataTableOperaRecords",
  "cmsSyncIndex",

  "mobile",
  "mobileFlowChart",
  "mobileLogin",
  //我的网盘
  "myNetworkDisk",
  "myFile",
  "recyclingStation",
  "myShare",
  "sharedSpace",
  "PublishMessage",
  "TemplateLibrary",
  "MyRelease",
  "MessageEdit",
  "MessageDetails",
  "messageApp",
  "publishDetails",
  "MessagePreview",
  "wechatLogin",
  "ScanCode",
  // 大屏
  "personnelOverview",
  "schoolOverview",
  "teachingOverview",
  "assetOverview",
  "producteduOverview",
  "AIformWrite",
];

//demo路由
const demoRoutes = ["helpCenter"];

/**
 *  路由拦截
 *  所有需要鉴权的页面,如果存储登录态的cookie不存在就跳登录页
 */
router.beforeEach((to, from, next) => {
  const token = store.getters.gtt_token,
    authMenu = store.getters.gtt_authMenu;
  //demo路由加入
  if (Object.prototype.toString.call(authMenu) === "[object Object]") {
    demoRoutes.map((item) => {
      if (
        authMenu.cms.length > 0 &&
        authMenu.cms.findIndex((menu) => menu === item) === -1
      ) {
        authMenu.cms.push(item);
      }
    });
  } else {
    demoRoutes.map((item) => {
      if (
        authMenu.length > 0 &&
        authMenu.findIndex((menu) => menu === item) === -1
      ) {
        authMenu.push(item);
      }
    });
  }

  if (to.name === from.name && to.fullPath === from.fullPath) {
    //不处理
  } else if (
    accessList.includes(to.name) ||
    to.path.indexOf("notice") !== -1 ||
    to.path.indexOf("taskHistoricalRecord") !== -1 ||
    to.path.indexOf("news") !== -1
  ) {
    next(true);
  } else {
    if (token) {
      if (
        authMenu.includes(to.name) ||
        ["educationBrainScreen"].includes(to.name) ||
        to.path.indexOf("cmsResourceCenter") !== -1
      ) {
        //匹配权限菜单
        next(true);
      } else {
        Vue.prototype.$message.error("无资源访问权限");
        next({ name: "notFound" });
      }
      //开发期间，放开所有路由
      // next(true);
    } else {
      if (
        ["feedbackIndex", "eventServiceIndex", "dataServiceIndex"].includes(
          to.name
        )
      ) {
        next(true);
      } else {
        // next({ name: "notFound" });
        //开发期间，放开所有路由
        next(true);
      }
    }
  }
});

export default router;
